import { render, staticRenderFns } from "./IconBar.vue?vue&type=template&id=4ab29fe1&"
import script from "./IconBar.vue?vue&type=script&lang=js&"
export * from "./IconBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "IconBar.vue"
export default component.exports